import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconInstagram = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 15 15",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M7.5,1.8c1.9,0,2.1,0,2.8,0c0.4,0,0.9,0.1,1.3,0.2c0.3,0.1,0.6,0.3,0.8,0.5     c0.2,0.2,0.4,0.5,0.5,0.8c0.2,0.4,0.2,0.9,0.2,1.3c0,0.7,0,1,0,2.8s0,2.1,0,2.8c0,0.4-0.1,0.9-0.2,1.3c-0.2,0.6-0.7,1.1-1.3,1.3     c-0.4,0.2-0.9,0.2-1.3,0.2c-0.7,0-1,0-2.8,0s-2.1,0-2.8,0c-0.4,0-0.9-0.1-1.3-0.2c-0.3-0.1-0.6-0.3-0.8-0.5     c-0.2-0.2-0.4-0.5-0.5-0.8c-0.2-0.4-0.2-0.9-0.2-1.3c0-0.7,0-1,0-2.8s0-2.1,0-2.8c0-0.4,0.1-0.9,0.2-1.3c0.1-0.3,0.3-0.6,0.5-0.8     C2.8,2.3,3.1,2.2,3.4,2c0.4-0.2,0.9-0.2,1.3-0.2C5.4,1.8,5.6,1.8,7.5,1.8 M7.5,0.5c-1.9,0-2.1,0-2.9,0C4,0.6,3.5,0.7,2.9,0.9     C2.4,1,2,1.3,1.7,1.7C1.3,2,1,2.4,0.9,2.9C0.7,3.5,0.6,4,0.5,4.6c0,0.7,0,1,0,2.9s0,2.1,0,2.9c0,0.6,0.1,1.2,0.3,1.7     C1,12.6,1.3,13,1.7,13.3C2,13.7,2.4,14,2.9,14.1c0.5,0.2,1.1,0.3,1.7,0.3c0.7,0,1,0,2.9,0s2.1,0,2.9,0c0.6,0,1.2-0.1,1.7-0.3     c0.9-0.4,1.7-1.1,2-2c0.2-0.5,0.3-1.1,0.3-1.7c0-0.7,0-1,0-2.9s0-2.1,0-2.9c0-0.6-0.1-1.2-0.3-1.7C14,2.4,13.7,2,13.3,1.7     C13,1.3,12.6,1,12.1,0.9c-0.5-0.2-1.1-0.3-1.7-0.3C9.6,0.5,9.4,0.5,7.5,0.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M7.5,3.9c-2,0-3.6,1.6-3.6,3.6s1.6,3.6,3.6,3.6s3.6-1.6,3.6-3.6l0,0     C11.1,5.5,9.5,3.9,7.5,3.9 M7.5,9.8c-1.3,0-2.3-1-2.3-2.3s1-2.3,2.3-2.3s2.3,1,2.3,2.3S8.8,9.8,7.5,9.8L7.5,9.8"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M12.1,3.8c0,0.5-0.4,0.8-0.8,0.8s-0.8-0.4-0.8-0.8s0.4-0.8,0.8-0.8S12.1,3.3,12.1,3.8     L12.1,3.8"
		})
	]
});
export { SvgIconInstagram as ReactComponent };
